import React from 'react'

const ForDetail = () => {
  return (
    <div className='flex mt-3 items-center'>
    <div>
      <span className='block text-customGray2 text-16'>Detaylar İçin</span>
      <div className='h-px w-0 bg-customGray2 group-hover:w-full ease-out duration-300'></div>
    </div>
    <img src='/images/icons/arrow.svg' className='h-2.5 group-hover:translate-x-1 ease-out duration-300' alt="Arrow" />
  </div>
  )
}

export default ForDetail